var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<tr> <td class="image hidden-xs"><img id="cartListItem_imgImage01" src="'+
((__t=( model.Image01 ))==null?'':__t)+
'" alt="product"></td> <td class="details"> <div class="clearfix"> <div class="pull-left no-float-xs"> <a href="#" class="title">'+
((__t=( model.Name ))==null?'':__t)+
'</a> </div> <div id="cartListItem_divBtn" class="action pull-right no-float-xs"> <div class="clearfix"> <button class="edit"><i class="fa fa-pencil"></i></button> <button class="refresh"><i class="fa fa-refresh"></i></button> <button class="delete" id="cartListItem_btnDelete"><i class="fa fa-trash-o"></i></button> </div> </div> </div> </td> <td class="qty"> <input id="cartListItem_inputQty" value="'+
((__t=( model.Qty ))==null?'':__t)+
'" name=""> </td> <td class="unit-price hidden-xs"><span class="currency">'+
((__t=( model.Currency ))==null?'':__t)+
'</span>'+
((__t=( model.Price ))==null?'':__t)+
'</td> <td class="total-price" id="cartListItem_tdTotalPrice"><span class="currency">'+
((__t=( model.Currency ))==null?'':__t)+
'</span>'+
((__t=( model.TotalPrice ))==null?'':__t)+
'</td> </tr>';
}
return __p;
};
